/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../buttons/apple-pay-button/apple-pay-button.component.ngfactory';
import * as import2 from '../../../buttons/apple-pay-button/apple-pay-button.component';
import * as import3 from '../../payment.model';
import * as import4 from '../../../page-layout/page-footer-control.directive';
import * as import5 from '../../../buttons/google-pay-button/google-pay-button.component.ngfactory';
import * as import6 from '../../../buttons/google-pay-button/google-pay-button.component';
import * as import7 from '../../../orchestration/session.model';
import * as import8 from '../../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import9 from '../../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import10 from '../../../orchestration/page';
import * as import11 from '../../../orchestration/navigation.service';
import * as import12 from '../../../order/order-totals-panel/order-totals-panel.component.ngfactory';
import * as import13 from '../../../order/order-totals-panel/order-totals-panel.component';
import * as import14 from '../../../ordering-context/ordering-context.model';
import * as import15 from '../../../order/order.model';
import * as import16 from '@angular/common';
import * as import17 from './wallet-payment-page.component';
import * as import18 from '../../../ui-elements/loading/loading.service';
const styles_WalletPaymentPageComponent:any[] = ([] as any[]);
export const RenderType_WalletPaymentPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_WalletPaymentPageComponent,
  data: {}
}
);
function View_WalletPaymentPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-apple-pay-button',[
      [
        'id',
        'apple-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'paymentStarted'
      ]
      ,
      [
        (null as any),
        'paymentComplete'
      ]
      ,
      [
        (null as any),
        'paymentFailed'
      ]
      ,
      [
        (null as any),
        'paymentCancelled'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('paymentStarted' === en)) {
        const pd_1:any = ((<any>co.paymentStarted()) !== false);
        ad = (pd_1 && ad);
      }
      if (('paymentComplete' === en)) {
        const pd_2:any = ((<any>co.paymentComplete($event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('paymentFailed' === en)) {
        const pd_3:any = ((<any>co.paymentFailed($event)) !== false);
        ad = (pd_3 && ad);
      }
      if (('paymentCancelled' === en)) {
        const pd_4:any = ((<any>co.paymentCancelled()) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },import1.View_ApplePayButtonComponent_0,import1.RenderType_ApplePayButtonComponent)),
    import0.ɵdid(4964352,(null as any),0,import2.ApplePayButtonComponent,[
      import0.ElementRef,
      import3.PaymentModel,
      import0.ChangeDetectorRef
    ]
      ,{type: [
        0,
        'type'
      ]
    },{
      paymentStarted: 'paymentStarted',
      paymentComplete: 'paymentComplete',
      paymentFailed: 'paymentFailed',
      paymentCancelled: 'paymentCancelled'
    }
    ),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import4.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_2:any = 'plain';
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_WalletPaymentPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-google-pay-button',[
      [
        'id',
        'google-pay-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'paymentStarted'
      ]
      ,
      [
        (null as any),
        'paymentComplete'
      ]
      ,
      [
        (null as any),
        'paymentFailed'
      ]
      ,
      [
        (null as any),
        'paymentCancelled'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('paymentStarted' === en)) {
        const pd_0:any = ((<any>co.paymentStarted()) !== false);
        ad = (pd_0 && ad);
      }
      if (('paymentComplete' === en)) {
        const pd_1:any = ((<any>co.paymentComplete($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('paymentFailed' === en)) {
        const pd_2:any = ((<any>co.paymentFailed($event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('paymentCancelled' === en)) {
        const pd_3:any = ((<any>co.paymentCancelled()) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },import5.View_GooglePayButtonComponent_0,import5.RenderType_GooglePayButtonComponent)),
    import0.ɵdid(4898816,(null as any),0,import6.GooglePayButtonComponent,[
      import0.ElementRef,
      import3.PaymentModel,
      import0.ChangeDetectorRef,
      import7.SessionModel
    ]
      ,{type: [
        0,
        'type'
      ]
    },{
      paymentStarted: 'paymentStarted',
      paymentComplete: 'paymentComplete',
      paymentFailed: 'paymentFailed',
      paymentCancelled: 'paymentCancelled'
    }
    ),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import4.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_2:any = 'plain';
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export function View_WalletPaymentPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),14,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import8.View_ModalPageLayoutComponent_0,import8.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import9.ModalPageLayoutComponent,[
      import10.Page,
      import11.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      showContent: [
        1,
        'showContent'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import10.PageLayout,(null as any),[import9.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),6,1,'woa-order-totals-panel',[
      [
        'class',
        'payment-totals'
      ]
      ,
      [
        'slot',
        'footer-start'
      ]

    ]
    ,(null as any),(null as any),(null as any),import12.View_OrderTotalsPanelComponent_0,import12.RenderType_OrderTotalsPanelComponent)),
    import0.ɵdid(180224,(null as any),0,import13.OrderTotalsPanelComponent,[
      import14.OrderingContextModel,
      import15.OrderModel,
      import11.NavigationService,
      import0.ChangeDetectorRef
    ]
      ,{totalOnly: [
        0,
        'totalOnly'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_WalletPaymentPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_WalletPaymentPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import16.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import17.WalletPaymentPageComponent = v.component;
    const currVal_0:any = 'woa.heading.wallet-payment.title';
    const currVal_1:any = false;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = true;
    ck(v,8,0,currVal_2);
    const currVal_3:any = (co.paymentModel.walletPaymentProcessor.walletProvider === co.WalletProvider.APPLE_PAY);
    ck(v,11,0,currVal_3);
    const currVal_4:any = (co.paymentModel.walletPaymentProcessor.walletProvider === co.WalletProvider.GOOGLE_PAY);
    ck(v,14,0,currVal_4);
  },(null as any));
}
function View_WalletPaymentPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-wallet-payment-page',([] as any[]),(null as any),(null as any),(null as any),View_WalletPaymentPageComponent_0,RenderType_WalletPaymentPageComponent)),
    import0.ɵdid(49152,(null as any),0,import17.WalletPaymentPageComponent,[
      import3.PaymentModel,
      import11.NavigationService,
      import18.LoadingService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import10.Page,(null as any),[import17.WalletPaymentPageComponent])
  ]
  ,(null as any),(null as any));
}
export const WalletPaymentPageComponentNgFactory:import0.ComponentFactory<import17.WalletPaymentPageComponent> = import0.ɵccf('woa-wallet-payment-page',import17.WalletPaymentPageComponent,View_WalletPaymentPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/payment/wallet-payment/wallet-payment-page/wallet-payment-page.component.ngfactory.ts